<template>
  <div class="relative">
    <img :src="finalSrc" alt="" :width="width" />
    <span class="text-red absolute" style="top: -8px; right: -4px" @click="onRemove">
      <i class="icon-a-02shanchu"></i>
    </span>
  </div>
</template>

<script>
import { convertDownloadUrl } from '@/api/file'

export default {
  name: 'ImageBox',
  props: {
    src: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      default: 66
    }
  },
  computed: {
    finalSrc() {
      return convertDownloadUrl(this.src)
    }
  },
  methods: {
    onRemove() {
      this.$emit('remove')
    }
  }
}
</script>
